import { PopoverComponents } from "./state/sidebar.slice.types";
import { LevelSelectorComponent } from "./sitemap-level-selector";
import { MapSettingsComponent } from "./map-settings";
import { SitemapSelectorComponent } from "./sitemap-selector";
import { ViewBySelectorComponent } from "./sidebar-library/view-by-selector";
import { SearchComponent } from "./search";

export const popoverComponents = {
    [PopoverComponents.MAP_SETTINGS]: MapSettingsComponent,
    [PopoverComponents.VIEW_BY]: ViewBySelectorComponent,
    [PopoverComponents.SITEMAP_SELECTOR]: SitemapSelectorComponent,
    [PopoverComponents.LEVEL_SELECTOR]: LevelSelectorComponent,
    [PopoverComponents.SEARCH]: SearchComponent,
};
